export const WC_PROJECT_ID = process.env.WALLET_CONNECT_PROJECT_ID;

import { bsc, mainnet, polygon } from 'viem/chains';

// export const USDC_MOCK_ADDRESS = '0x2b17733F3D3B9eE6a3557B10132Fac99e6a8B515';
export const USDT_POLYGON_ADDRESS = '0xc2132D05D31c914a87C6611C10748AEb04B58e8F';
// export const USDC_MOCK_ADDRESS = '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359';
export const TICKET_PRICE_ABI = [
	{
		inputs: [],
		name: 'ticketPrice',
		outputs: [{ name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function',
	},
];

export const TICKET_CONTRACT_ABI = [
	{
		inputs: [],
		name: 'ticketPrice',
		outputs: [{ name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function',
	},

	{
		inputs: [{ name: 'amount', type: 'uint256' }],
		name: 'buyTicket',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function',
	},
];

export const IERC20_ABI = [
	{
		constant: true,
		inputs: [
			{ name: 'owner', type: 'address' },
			{ name: 'spender', type: 'address' },
		],
		name: 'allowance',
		outputs: [{ name: '', type: 'uint256' }],
		type: 'function',
	},
	{
		inputs: [
			{ name: 'spender', type: 'address' },
			{ name: 'amount', type: 'uint256' },
		],
		name: 'approve',
		outputs: [{ name: '', type: 'bool' }],
		stateMutability: 'nonpayable',
		type: 'function',
	},
];

export const EXTRACT_TICKET_LOGS_ABI = [
	{
		anonymous: false,
		inputs: [
			{ indexed: true, name: 'buyer', type: 'address' },
			{ indexed: true, name: 'ticketId', type: 'uint256' },
			{ indexed: false, name: 'paymentHash', type: 'bytes32' },
		],
		name: 'TicketPurchased',
		type: 'event',
	},
] as const;
export const TON_BUY_TICKET_CONTRACT = 'EQAB8Nf7PoZtkaTAdcRaqC6XR6rHzasm7bFz96quJrrCE9wN';
export const CHAIN_CONTRACTS: Record<
	string,
	{
		chainId: 1 | 56 | 137;
		chainName: string;
		decimals: number;
		img: string;
		name: string;
		smartContractUSDC: `0x${string}`;
		smartContractUSDT: `0x${string}`;
		usdc: `0x${string}`;
		usdt: `0x${string}`;
	}
> = {
	bsc: {
		chainId: bsc.id,
		chainName: 'BSC',
		decimals: 18,
		img: 'bep.png',
		name: 'BNB Chain (BEP-20)',
		smartContractUSDC: '0xd9d1E1AE17A58D3b667Caf1Aa1B01AB5E5AD2CA3',
		smartContractUSDT: '0xA6022FcDd6edB4d710Aed365ae468f79e5f415a3',
		usdc: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
		usdt: '0x55d398326f99059fF775485246999027B3197955',
	},
	mainnet: {
		chainId: mainnet.id,
		chainName: 'ERC20',
		decimals: 6,
		img: 'ethereum.png',
		name: 'Ethereum (ERC-20)',
		smartContractUSDC: '0x7AD61f19bAD6A7e715Dc8DAd83A6210BcF8b2611',
		smartContractUSDT: '0xEE9622710A84b700E0BEBe91CBCAeF605f857413',
		usdc: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
		usdt: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
	},
	polygon: {
		chainId: polygon.id,
		chainName: 'Polygon',
		decimals: 6,
		img: 'polygon.png',
		name: 'Polygon (POL)',
		smartContractUSDC: '0xec9834E97112f11E7ba915b04424D85C6D315eF9',
		smartContractUSDT: '0x874Fd907a51A28BF7f2b1117eEEd93Aa0D1A2b13',
		usdc: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
		usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
	},
};
